export const FOREIGNTRAVEL_DATA_REQUEST = 'FOREIGNTRAVEL_DATA_REQUEST';
export const FOREIGNTRAVEL_DATA_SUCCESS = 'FOREIGNTRAVEL_DATA_SUCCESS';
export const FOREIGNTRAVEL_DATA_FAIL = 'FOREIGNTRAVEL_DATA_FAIL';
